<template>
  <v-container fluid>
    <v-card class="pa-8">
      <div class="d-flex align-center mb-8">
        <v-select
          v-model="selectedSoftware"
          :items="softwareItems"
          label="Выберите модуль"
          item-text="text"
          item-value="value"
          outlined
          hide-details
          class="ml-4"
          style="width: 500px"
        ></v-select>

        <v-autocomplete
          v-model="selectedObject"
          :items="ObjectItems"
          label="Выберите объект"
          item-text="text"
          item-value="value"
          outlined
          hide-details
          clearable
          class="ml-4"
          style="width: 500px"
        />

        <v-btn @click="applySelection" color="green" dark class="ml-4">
          Применить фильтр
        </v-btn>
        <v-btn @click="createExcel" :color="hasData ? 'green' : 'grey'" dark class="ml-4">
          Выгрузить в xlsx
        </v-btn>
      </div>
        <div
        v-for="cfg in configs"
        :key="`${cfg.object_id}-${cfg.last_date_update}`"
        class="mb-6"
        >
        <v-card outlined>
            <v-card-title class="text-h6">Информация об объекте</v-card-title>
            <v-card-text>
            <v-simple-table dense>
                <tbody>
                <tr>
                    <td><strong>ID</strong></td>
                    <td>{{ cfg.id }}</td>
                </tr>
                <tr>
                    <td><strong>Код объекта</strong></td>
                    <td>{{ cfg.object_code }}</td>
                </tr>
                <tr>
                    <td><strong>Название объекта</strong></td>
                    <td>{{ cfg.object_name }}</td>
                </tr>
                <tr>
                    <td><strong>Код лицензии</strong></td>
                    <td>{{ cfg.license_code }}</td>
                </tr>
                <tr>
                    <td><strong>Код мастера</strong></td>
                    <td>{{ cfg.master_code }}</td>
                </tr>
                <tr>
                    <td><strong>Имя дилера</strong></td>
                    <td>{{ cfg.dealer_name }}</td>
                </tr>
                <tr>
                    <td><strong>Дата последнего обновления</strong></td>
                    <td>{{ formatDate(cfg.last_date_update) }}</td>
                </tr>
                </tbody>
            </v-simple-table>
            </v-card-text>

            <v-divider></v-divider>

          <v-card-title class="d-flex justify-space-between align-center">
            <span class="text-h6">Конфигурация</span>
            <div>
              <v-btn
                small
                color="green"
                dark
                class="mr-2"
                @click="toggleConfig(cfg)"
              >
                {{ cfg.showConfig ? 'Скрыть конфиг' : 'Показать конфиг' }}
              </v-btn>
              <v-btn
                small
                color="blue"
                dark
                @click="copyConfig(cfg.config)"
              >
                Копировать
              </v-btn>
            </div>
          </v-card-title>

          <v-card-text v-if="cfg.showConfig">
            <pre>{{ formatConfig(cfg.config) }}</pre>
          </v-card-text>
        </v-card>
        </div>
      </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import axios from "axios";
import yaml from "js-yaml";

export default {
  data() {
    return {
      selectedSoftware: null,
      softwareItems: [],
      selectedObject: null,
      ObjectItems: [],
      loading: false,
      tableHeaders: [],
      tableItems: [],
      hasData: null,
      dateBegin: null,
      dateEnd: null,
      configs: [],
    };
  },
  watch: {
    selectedSoftware: {
      immediate: true,
      handler: async function (newVal) {
        if (newVal) {
          await this.loadObjects(newVal);
        } else {
          this.ObjectItems = [];
          this.selectedObject = null;
        }
      },
    },
  },
  computed: {
    ...mapGetters(["seriesNamesDetail", "chartSeriesDetail", "analyticsData", "softwareData", "url"]),
    getNames() {
      return this.seriesNamesDetail;
    },
    getSeries() {
      return this.chartSeriesDetail;
    },
  },
  async created() {
    await this.createSoftwareData();
    this.prepareSoftwareItems();
  },
  methods: {
    ...mapActions(["createAnalyticsData", "createSoftwareData", "createExcelFile"]),
    ...mapMutations(["setSnackbar"]),

    prepareSoftwareItems() {
      this.softwareItems = Object.keys(this.softwareData).map((key) => ({
        text: this.softwareData[key],
        value: key,
      }));
    },

    async loadObjects(softwareCode) {
      try {
        this.loading = true;
        const response = await axios.post(this.url + "object_list", null, {
          params: { software_id: softwareCode },
        });
        this.ObjectItems = response.data.objects.map((obj) => ({
          text: obj.name,
          value: obj.code,
        }));
        this.selectedObject = null;
      } catch (err) {
        console.error("Ошибка при загрузке объектов:", err);
        this.ObjectItems = [];
        this.selectedObject = null;
      } finally {
        this.loading = false;
      }
    },

    async applySelection() {
      if (!this.selectedSoftware) {
        this.setSnackbar({ show: true, message: "Выберите модуль!", color: "error" });
        return;
      }

      if (!this.selectedObject) {
        this.setSnackbar({ show: true, message: "Выберите объект!", color: "error" });
        return;
      }

      this.loading = true;
      try {
        const response = await axios.post(this.url + "soft_configs", null, {
          params: {
            software_code: this.selectedSoftware,
            object_code: this.selectedObject,
          },
        });
        this.configs = response.data.configs || [];
      } catch (err) {
        console.error("Ошибка при применении фильтра:", err);
        this.configs = [];
      } finally {
        this.loading = false;
      }
    },

    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleString();
    },

    formatConfig(cfg) {
      try {
        return yaml.dump(cfg, { indent: 2, lineWidth: -1 });
      } catch (e) {
        console.error("Ошибка преобразования в YAML:", e);
        return cfg;
      }
    },
    toggleConfig(cfg) {
      this.$set(cfg, "showConfig", !cfg.showConfig);
    },
    copyConfig(cfg) {
      try {
        const text = yaml.dump(cfg, { indent: 2, lineWidth: -1 });
        navigator.clipboard.writeText(text);
        this.setSnackbar({ show: true, message: "Конфиг скопирован!", color: "success" });
      } catch (err) {
        this.setSnackbar({ show: true, message: "Ошибка при копировании", color: "error" });
      }
    },
  },
};
</script>

<style scoped>
pre {
  background-color: #f5f5f5;
  padding: 10px;
  border-radius: 4px;
  overflow-x: auto;
}
</style>
